import { React, useEffect, useState} from "react";
import "./ViewCandidateNomination.css";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MyNominationFilter from './MyNominationFilter';
import TablePagination from "@mui/material/TablePagination";
import {fetchPOCUploadedIndividualList,updateLoginUserName} from "../Redux/BussinessPOCSlice";
import { useMsal } from "@azure/msal-react";
import { CSVLink } from "react-csv";
import MyNominationSearch from "./MyNominationSearch";
import MyNominationDateFilter from "./MyNominationDateFilter";

const MyNominations = () => { 
 const [page, setPage] = useState(0);
 const dispatch = useDispatch();
 const nominationList = useSelector((state) => state.poc.individualCourseList);  
 const [userEnterpriseID, setuserEnterpriseID] = useState(null);  
 const [rowsPerPage, setRowsPerPage] = useState(25);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount(); 
 const [filteredData, setFilteredData] = useState([]);
 const [downloadData, setDownloadData] = useState([]);    

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };  
 
  useEffect(() => {        
    setFilteredData(nominationList);
  },[nominationList])
 
  useEffect(() => {
    if (activeAccount) {
      dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
      setuserEnterpriseID(activeAccount.idTokenClaims.enterpriseID);
    } else {
      dispatch(updateLoginUserName(null));
      setuserEnterpriseID(null);
    }
  }, [activeAccount]);

  useEffect(() => {    
    userEnterpriseID !== null && dispatch(fetchPOCUploadedIndividualList(userEnterpriseID,'01/01/2024','26/05/2024'));    
  }, [userEnterpriseID]);

  const theme = createTheme({
    typography: {
    fontFamily: "Graphik-Regular",
    },
  });

  const headers = [    
    { label: "Enterprise ID", key: "enterpriseID" },
    { label: "Course Name", key: "courseName" },    
    { label: "Mode", key: "deliveryMode" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },    
    { label: "Status", key: "status" }    
  ];

  let statusDetail = {
    1: "Waiting for Approval",
    2: "Waiting for Batch Allocation",
    3: "Rejected",
    4: "Scheduled",
    5: "Rejected",
    6: "Nomination Failed"    
  }

  useEffect(() => {             
    const modifiedDownloadData = filteredData.map(obj => ({ ...obj, 
      status: statusDetail[obj.status], 
      startDate: `${obj.startDate.split("/")[2]}-${obj.startDate.split("/")[1]}-${obj.startDate.split("/")[0]}`,
      endDate: `${obj.endDate.split("/")[2]}-${obj.endDate.split("/")[1]}-${obj.endDate.split("/")[0]}`
    }));    
    setDownloadData(modifiedDownloadData);
  }, [filteredData]);

 return (
  <ThemeProvider theme={theme}>      
    <Box className="upload_table my_nomination_table_container" style={{marginTop: '40px'}}>
    <div className="download_pagination_section">                                                          
        <div className="table-top-header-left-section">
          <MyNominationDateFilter userEnterpriseID={userEnterpriseID}/>                                              
          {filteredData.length !== 0 && <CSVLink data={downloadData} headers={headers} filename={"my-nominations.csv"} target="_blank" className="download_mynominations">
            Download
          </CSVLink>}
        </div>        
        {filteredData.length !== 0 && <>          
          <TablePagination className="upload_nomination_pagination" component="div" count={filteredData != undefined && filteredData.length != 0 ? filteredData.length : null}
            page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ visibility:filteredData != undefined && filteredData.length > 0 ? "visible" : "hidden",}}
          />
        </>
        }
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
          <TableRow>
            <TableCell align="left">Sl No</TableCell>
            <TableCell align="left" className="Enterprise_id_cell">              
              Enterprise ID
              <MyNominationSearch filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} 
                skillType='enterprise_id' />              
            </TableCell>

            <TableCell align="left">
              Course Name
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='course_name'/>
            </TableCell>            
            <TableCell align="left">
              Mode              
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='mode'/>
            </TableCell>
            <TableCell align="left">
              Start Date
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='start_date'/>
            </TableCell>                        
            <TableCell align="left">
              End Date              
            </TableCell>            
            <TableCell align="left">
              Status
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='status'/>
              </TableCell>
          </TableRow>
          </TableHead>
          <TableBody>              
            {filteredData.length !== 0 && filteredData.map((row, index) => (              
              <TableRow key={index}>
                <TableCell align="left" scope="row">
                {index + 1}.
                </TableCell>
                <TableCell align="left" scope="row">
                {row.enterpriseID}
                </TableCell>
                <TableCell align="left">{row.courseName}</TableCell>                
                <TableCell align="left">{row.deliveryMode}</TableCell>
                <TableCell align="left">{row.startDate}</TableCell>                                
                <TableCell align="left">{row.endDate}</TableCell>
                <TableCell align="left">
                {row.status == 1 ? (
                  <div className="status_requested_viewnominationtable">
                  <span>Waiting for Approval</span>
                  </div>
                ) : row.status == 2 ? (
                  <div className="status_approved_viewnominationtable">
                  <span>Waiting for Batch Allocation</span>
                  </div>
                ) : row.status == 3 ? (
                  <div className="status_rejected_viewnominationtable_section">
                  <span className="status_rejected_viewnominationtable">Rejected</span>
                  <span className="reason_span">{row.reason}</span>
                  </div>
                ) : row.status == 4 ? (
                  <div className="status_scheduled_viewnominationtable">
                  <span>Scheduled</span>
                  </div>
                ) : row.status == 5 ? (
                  <div className="status_waitlistes_viewnominationtable">
                  <span>Rejected</span>
                  </div>
                ) : row.status == 6 ? (
                  <div className="status_waitlistes_viewnominationtable">
                  <span>Nomination Failed</span>
                  </div>
                ) : null}
                </TableCell>
              </TableRow>
            ))}
            {filteredData.length === 0 && <TableRow><TableCell colSpan={7}>No Nominations Found.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>      
      <TablePagination className="upload_nomination_pagination" component="div" count={filteredData != undefined && filteredData.length != 0 ? filteredData.length : null}
        page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ width: "100% !important",visibility:filteredData != undefined && filteredData.length > 0 ? "visible" : "hidden",}}
      />
    </Box>   
  </ThemeProvider>
 );
};

export default MyNominations;
